export default "__VITE_ASSET__BPYzJM5L__"